import { findIndex, isEmpty } from 'lodash';

import * as types from './constants';
import { removeFromQueryString } from '../../utils/queryString';

const initialState = {
  data: {},
  getLoading: false,
  errors_api: {},
  filters: [
    { key: 'category', filterTitle: 'Category', selected: false, value: [] },
    { key: 'everyone', filterTitle: 'Everyone', selected: false, value: [] }
  ],
  queryParsed: false
};

const actions = {
  // Get Notifications
  [types.GET_NOTIFICATIONS_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_NOTIFICATIONS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.GET_NOTIFICATIONS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Get Operations
  [types.SET_NOTIFICATIONS_FILTER]: (state, { payload }) => {
    const index = findIndex(state.filters, x => x.key === payload.key);
    const updatedFilters = [...state.filters];
    if (index !== -1) {
      updatedFilters[index].value = payload.value;
      updatedFilters[index].selected = isEmpty(updatedFilters[index].value) ? false : true;
    }

    const data = {
      ...state,
      filters: updatedFilters
    };

    return { ...data };
  },

  [types.SET_NOTIFICATIONS_ALL_FILTERS]: (state, { payload }) => {
    let updatedFilters = [...state.filters];

    payload.forEach(filter => {
      const index = findIndex(updatedFilters, x => x.key === filter.key);
      if (index !== -1) updatedFilters[index] = { ...updatedFilters[index], ...filter, selected: true };
    });

    const data = {
      ...state,
      filters: updatedFilters,
      queryParsed: true
    };

    return { ...data };
  },

  [types.CLEAR_NOTIFICATIONS_FILTERS]: (state, { payload: { filterToUpdate, mobile } }) => {
    if (!isEmpty(filterToUpdate)) {
      const index = findIndex(state.filters, x => x.key === filterToUpdate.key);
      const updatedFilters = [...state.filters];
      if (index !== -1) {
        updatedFilters[index].value = filterToUpdate.value;
        updatedFilters[index].selected = filterToUpdate.selected;
      }

      const data = {
        ...state,
        filters: updatedFilters
      };
  
      if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}${removeFromQueryString(filterToUpdate.key)}`);

      return { ...data };
    } else {
      const data = {
        ...state,
        filters: [
          { key: 'category', filterTitle: 'Category', selected: false, value: [] },
          { key: 'everyone', filterTitle: 'Everyone', selected: false, value: [] }
        ]
      };

      if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}`);

      return { ...data };
    }
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};